import React, { useEffect, useRef } from "react";
import FileDropAnimation from "./Animations/DropFile";
import LLMsAnimation from "./Animations/LLMsAnimation";
import TeamScalingAnimation from "./Animations/TeamScalingAnimation";
import { useLanguage } from "../../Translations/LenguageContext";

const UseCase = ({ selectedLink, setSelectedLink }) => {
  const {t} = useLanguage()
  const dataRef = useRef(null);
  const intelligenceRef = useRef(null);
  const scaleRef = useRef(null);

  const useCasesData = [
    {
      kicker: t.website.use_cases.use_case_data[0].kicker,
      title: t.website.use_cases.use_case_data[0].title,
      desc:  t.website.use_cases.use_case_data[0].desc,
      bg: "linear-gradient(135deg, rgba(20, 20, 150, 0.2), rgba(0, 120, 100, 0.5))",
      ref: dataRef,
    },
    {
      kicker: t.website.use_cases.use_case_data[1].kicker,
      title: t.website.use_cases.use_case_data[1].title,
      desc:  t.website.use_cases.use_case_data[1].desc,
      bg: "linear-gradient(135deg, rgba(150, 0, 100, 0.2), rgba(150, 127, 0, 0.2))",
      ref: intelligenceRef,
    },
    {
      kicker: t.website.use_cases.use_case_data[2].kicker,
      title: t.website.use_cases.use_case_data[2].title,
      desc:  t.website.use_cases.use_case_data[2].desc,
      bg: "linear-gradient(135deg, rgba(0, 150, 80, 0.2), rgba(0, 80, 150, 0.2))",
      ref: scaleRef,
    },
  ];

  useEffect(() => {
    // Scroll logic based on selectedLink
    switch (selectedLink) {
      case 2:
        dataRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        break;
      case 3:
        intelligenceRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        break;
      case 4:
        scaleRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        break;
      default:
        break;
    }
  }, [selectedLink]);

  return (
    <div className="use_case_cont">
      {useCasesData.map((item, index) => (
        <div className="usecase_card" key={index} ref={item.ref}>
          <div className="usecase_card_p">
            <p className="usecase_card_kicker">{item.kicker}</p>
            <p className="usecase_card_title">{item.title}</p>
            <p className="usecase_card_desc">{item.desc}</p>
          </div>
          <div className="usecase_card_img" style={{ background: item.bg }}>
            {index === 0 && <FileDropAnimation />}
            {index === 1 && <LLMsAnimation />}
            {index === 2 && <TeamScalingAnimation />}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UseCase;
